import React, { useMemo } from "react"
import classnames from "classnames"
import ImageWrapper from "../../macro-component/ImageWrapper"
import ImageComponent from "../Image"
import "../tailwind.css"
const classes = {
  textSize: {
    xs: "text-xs",
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg",
    xl: "text-xl",
  },
  padding: {
    large: "px-4 py-2",
    medium: "p-2",
    small: "p-1",
  },
  borderRadius: {
    none: "rounded-none",
    rounded: "rounded-3xl",
    fullRounded: "rounded-full",
  },
  margin: "m-1",
  color: {
    white: "text-primary",
    black: "text-black",
    info: "text-info",
    accent: "text-accent",
    primary: "text-primary",
    secondary: "text-secondary",
    tertiary: "text-tertiary",
    danger: "text-danger",
  },
  background: {
    primary: "bg-primary-default",
    secondary: "bg-secondary-default",
    tertiary: "bg-tertiary-default",
    danger: "bg-danger-default",
    text: "bg-transparent",
  },
  border: "border border-borderShade",
  display: "flex",
  alignItem: "items-center",
  flexDirection: {
    down: "flex-col",
    up: "flex-col-reverse",
    right: "flex-row",
    left: "flex-row-reverse",
  },
}

export default function Button({
  text = "",
  noHoverState = false,
  buttonType = "primary",
  fontSize = "md",
  textColor = "white",
  buttonSize = "large",
  rounded = "rounded",
  iconLocation = "left",
  isIcon = false,
  url = "/upload.svg",
  iconAltText = "upload",
  iconColor = "black",
  isNameIcon = false,
  iconName = "",
  imgHeight = 15,
  imgWidth = 15,
  disabled = false,
  className = "",
  labelClassNames = "",
  testId = "cta-button",
  border = true,
  // isLoading = false,
  fullWidth = false,
  iconClasName: iconClassName = "",
  children = undefined,
  iconFullWidth = true,
  ...restProps
}) {
  const textClasses = useMemo(
    () =>
      classnames(
        classes.display,
        classes.alignItem,
        classes.flexDirection[iconLocation as keyof typeof classes.flexDirection],
        fullWidth && "justify-center",
        labelClassNames,
      ),
    [iconLocation, labelClassNames, fullWidth],
  )
  return (
    <button
      className={classnames(
        buttonType !== "text" ? classes.margin : "",
        border ? classes.border : "",
        classes.textSize[fontSize as keyof typeof classes.textSize],
        classes.padding[buttonSize as keyof typeof classes.padding],
        classes.borderRadius[rounded as keyof typeof classes.borderRadius],
        classes.color[textColor as keyof typeof classes.color],
        disabled ? "bg-disabled" : classes.background[buttonType as keyof typeof classes.background],
        disabled ? " cursor-not-allowed" : " cursor-pointer",
        className,
        "transition duration-300 ease-in-out",
        {
          "hover:bg-primary-hover focus:bg-primary-focus": !disabled && buttonType === "primary" && !noHoverState,
          "hover:bg-secondary-hover focus:bg-secondary-focus": !disabled && buttonType === "secondary" && !noHoverState,
          "hover:bg-tertiary-hover focus:bg-tertiary-focus": !disabled && buttonType === "tertiary" && !noHoverState,
          "hover:bg-danger-hover focus:bg-danger-focus": !disabled && buttonType === "danger" && !noHoverState,
        },
      )}
      data-testid={testId}
      disabled={disabled}
      {...restProps}
    >
      <div className={textClasses}>
        {children || text}
        {isIcon && (
          <ImageComponent
            src={url}
            alt={iconAltText}
            height={imgHeight}
            width={imgWidth}
            className={`m-2 ${iconClassName}`}
            fullWidth={iconFullWidth}
          />
        )}
        {isNameIcon && (
          <ImageWrapper
            url={""}
            name={iconName}
            alt_text={iconAltText}
            height={imgHeight}
            width={imgWidth}
            className={`m-2 ${iconClassName}`}
            color={iconColor}
          />
        )}
      </div>
    </button>
  )
}
